import { useNavigate } from 'react-router';
import { orderBy, map, noop } from 'lodash';
import { IPatientTherapistHistory } from '../../../../services/clinicalRecordService/types';
import { ReactComponent as OnestepIcon } from '../../../../assets/icons/timeline/onestep.svg';
import useCurrentClinic from '../../../../hooks/useCurrentClinic';
import useClinicalRecordService from '../../../../services/clinicalRecordService';

export default function useTherapistHistoryEvent(patientUuid: string) {
  const navigate = useNavigate();
  const { record } = useClinicalRecordService(patientUuid);
  const { getMember } = useCurrentClinic();
  const therapistHistories = orderBy(
    (record?.patientTherapistHistory ?? []).slice(),
    (x) => x.createdAt,
    'asc'
  );
  return map(
    therapistHistories,
    ({ comment, createdAt, therapistUuid }: IPatientTherapistHistory) => {
      return {
        name: 'Therapist history',
        date: createdAt,
        icon: OnestepIcon,
        description: therapistUuid
          ? `Therapist ${
              getMember(therapistUuid)?.fullName
            } is assigned to this patient`
          : `Unassigned by ${comment || 'unknown'} for this patient`,
        ctaText: therapistUuid ? 'View Therapist' : '',
        cta() {
          therapistUuid ? navigate(`/therapists/${therapistUuid}`) : noop;
        },
      };
    }
  );
}
